export default __webpack_public_path__ + "static/media/bessou.a5119de9.jpeg";